import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async recent_sales(data) {
    let response = await apiCall("fuel_sales/recent_sales", data);
    return response;
  },
  async best_station_attendant_in_sales(data) {
    let response = await apiCall("fuel_sales/monthly_best_attendant", data);
    return response;
  },
  async monthly_attendant_sales(data) {
    let response = await apiCall(
      "fuel_sales/monthly_sales_per_attendant",
      data
    );
    return response;
  },
  async monthly_sales_per_station_graph(data) {
    let response = await apiCall(
      "fuel_sales/monthly_sales_per_station_graph",
      data
    );
    return response;
  },
  async monthly_best_station(data) {
    let response = await apiCall("fuel_sales/monthly_best_station", data);
    return response;
  },
};
